export default __webpack_public_path__ + "static/media/video-poster.865b4ce4.jpeg";